module.exports = __webpack_public_path__ + "img/sv.a64aa0bf.svg";